import { Button, Flex } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useState } from 'react';

import { useCustomGeolocated } from '@jane/bloom/hooks/storeSwitcher/useCustomGeolocated';
import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';

import { AddressField } from './addressField';
import { AddressSuggestions } from './addressSuggestions';
import { LocationButton } from './locationButton';
import { NearbyStores } from './nearbyStores';
import { StoreSwitcherError } from './storeSwitcherError';
import styles from './storeSwitcherForm.module.css';
import { StoreSwitcherReservationModes } from './storeSwitcherReservationModes';
import { StoreSwitcherStoreTypes } from './storeSwitcherStoreTypes';

export function StoreSwitcherForm() {
  const {
    addressSuggestions,
    displayAddressSuggestions,
    handleSearchAddressChanged,
    inDeliveryRange,
    isUndeliverableAddress,
    searchAddress,
    searchReservationMode,
    setBusy,
    setLocationButtonDisabled,
    toggleVisibility,
    updateShoppingPreferences,
    validateAddress,
    validationState,
  } = useStoreSwitcher();

  const [displayAddress, setDisplayAddress] = useState(searchAddress);

  const { triggerLocationPrompt } = useCustomGeolocated({
    handleDetectedAddress: (address) => {
      setDisplayAddress(address);
      validateAddress(address, searchReservationMode);
    },
    setBusy,
    setLocationButtonDisabled,
    updateShoppingPreferences,
  });

  const onAddressTextChange = (address: string) => {
    setDisplayAddress(address);
    handleSearchAddressChanged(address);
  };

  return (
    <>
      <div
        className={clsx(styles['form'], {
          [styles['form--withAddresses']]: addressSuggestions.length > 0,
        })}
      >
        <div className={styles['searchContainer']}>
          <AddressField
            displayAddress={displayAddress}
            onAddressTextChange={onAddressTextChange}
          />

          {!displayAddressSuggestions && (
            <LocationButton triggerLocationPrompt={triggerLocationPrompt} />
          )}

          {!displayAddressSuggestions && (
            <>
              <StoreSwitcherReservationModes />
              <StoreSwitcherStoreTypes />
            </>
          )}

          {!displayAddressSuggestions && isUndeliverableAddress && (
            <StoreSwitcherError error="For deliveries, please enter a full address." />
          )}

          {displayAddressSuggestions && (
            <AddressSuggestions setDisplayAddress={setDisplayAddress} />
          )}
        </div>
      </div>
      {!displayAddressSuggestions &&
        !isUndeliverableAddress &&
        (inDeliveryRange || validationState !== 'idle') && <NearbyStores />}

      {!inDeliveryRange &&
        !displayAddressSuggestions &&
        validationState === 'idle' &&
        !isUndeliverableAddress && (
          <Flex className={styles['unavailableError']}>
            <StoreSwitcherError error="Bummer! Delivery to your address isn't available right now. Try a different one or pick up in store." />
          </Flex>
        )}

      <div className={styles['closeContainer']}>
        <Button
          variant="secondary"
          onClick={toggleVisibility}
          label="Close"
          full
        />
      </div>
    </>
  );
}
